<script setup lang="ts">
import type { ConfigType } from '@/types/models/PartnerConfigModel'
import type { PartnerModel } from '@/types/partners/PartnerModel'
import { EditableTypedInput, StackLayout } from '@rfc/rfc-components-library'
import { localFallback } from '@rfc/rfc-components-library/locales'
import { type ExtendedPrimitives } from '@rfc/rfc-components-library/types'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

type Props = {
    partnerConfigData?: PartnerModel
    partnerConfig?: Record<string, ConfigType | string>
    partnerConfigValues?: Record<string, ExtendedPrimitives>
    editMode?: boolean
    boldLabel?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'update', value: Record<string, ExtendedPrimitives>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout direction="column" :gap="8" class="w-full" v-if="partnerConfig">
        <EditableTypedInput
            v-for="([itemKey, itemValue], key) in Object.entries(partnerConfig)"
            :key="key"
            :modelValue="partnerConfigValues?.[itemKey]"
            :label="
                (itemValue as ConfigType)?.label
                    ? (localFallback((itemValue as ConfigType)?.label, i18n) ?? itemKey)
                    : itemKey
            "
            :dataType="(itemValue as ConfigType)?.type ?? itemValue"
            :editMode="editMode"
            :boldLabel="boldLabel"
            @change="$emit('update', { ...(partnerConfigValues ?? {}), [itemKey]: $event })" />
    </StackLayout>
    <StackLayout direction="column" :gap="8" class="w-full" v-else-if="partnerConfigValues">
        <EditableTypedInput
            v-for="([itemKey, itemValue], key) in Object.entries(partnerConfigValues)"
            :key="key"
            :modelValue="itemValue"
            :label="itemKey"
            dataType="string"
            :editMode="editMode"
            :boldLabel="boldLabel"
            @change="$emit('update', { ...(partnerConfigValues ?? {}), [itemKey]: $event })" />
    </StackLayout>
</template>
